import { render, staticRenderFns } from "./ProgramEdit.vue?vue&type=template&id=00378e50&scoped=true&"
import script from "./ProgramEdit.vue?vue&type=script&lang=js&"
export * from "./ProgramEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProgramEdit.vue?vue&type=style&index=0&id=00378e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00378e50",
  null
  
)

export default component.exports